var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsa(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M65.894,71.295h-4.547v-6.547c0-1.104-0.896-2-2-2h-1.455V60.02c0-1.104-0.896-2-2-2h-0.546V34.104c0-1.104-0.896-2-2-2 h-0.91v-2.839c0-1.104-0.896-2-2-2h-0.434v-4.561c0-1.104-0.896-2-2-2c-1.104,0-2,0.896-2,2v4.561h-0.434c-1.104,0-2,0.896-2,2 v2.839h-0.91c-1.104,0-2,0.896-2,2V58.02h-0.549c-1.104,0-2,0.896-2,2v2.729h-1.455c-1.104,0-2,0.896-2,2v6.547h-4.547 c-1.104,0-2,0.896-2,2s0.896,2,2,2h35.788c1.104,0,2-0.896,2-2S66.998,71.295,65.894,71.295z M47.567,31.266h0.868v0.839h-0.868 V31.266z M44.658,36.104h6.688V58.02h-6.688V36.104z M42.108,62.02h11.783v0.729H42.108V62.02z M57.347,71.295H38.653v-4.547 h18.693V71.295z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsa);
export default __webpack_public_path__ + "static/media/usa.fcd3e8553beb47d611f430c47ee58287.svg";
export { ForwardRef as ReactComponent };